import { render, staticRenderFns } from "./phoneDiscussion.vue?vue&type=template&id=017a71e6"
import script from "./phoneDiscussion.vue?vue&type=script&lang=js"
export * from "./phoneDiscussion.vue?vue&type=script&lang=js"
import style0 from "./phoneDiscussion.vue?vue&type=style&index=0&id=017a71e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports